import { Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import Logo from "../../../assets/logo.webp";
import { RxHamburgerMenu } from "react-icons/rx";
import { FaTimes } from "react-icons/fa";
import styles from ".//Navbar.module.css";

const Header = () => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef();
  const openMobileNav = () => {
    setOpen(true);
  };
  const closeMobileNav = () => {
    setOpen(false);
  };

  useEffect(() => {
    const handler = (e) => {
      if (!menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, []);

  return (
    <div className={`${styles.header} `}>
      <div className={open ? `${styles.overlay}` : ""}></div>
      <nav className={styles.navbar}>
        <div className={`section ${styles.navSection} `}>
          <div className={styles.navContainer}>
            <div className={styles.user}>
              <button
                onClick={openMobileNav}
                className={styles.navToggle}
                aria-label="Navbar button"
              >
                <RxHamburgerMenu />
              </button>
              <Link to="/" aria-label="Read more about home">
                <button className={styles.login}>English</button>
              </Link>
            </div>
            <div className={styles.linksContainer}>
              <Link
                className={styles.link}
                to="/contact"
                aria-label="Read more about contact"
              >
                تواصل&nbsp;معنا
              </Link>
              <Link
                className={styles.link}
                to="/courses"
                aria-label="Read more about course"
              >
                الدورات
              </Link>
              <Link
                className={styles.link}
                to="/arabic"
                aria-label="Read more about home"
              >
                الرئيسية
              </Link>
            </div>
          </div>
          <Link
            className={styles.logo}
            to="/arabic"
            aria-label="Read more about home"
          >
            <span className={styles.logoIcon}>
              <img src={Logo} alt="Logo" width={60} />
            </span>
            <span className={styles.logoText}>APEI</span>
          </Link>
        </div>
      </nav>
      {/* Mobile navbar */}
      <div
        ref={menuRef}
        className={
          open
            ? `${styles.mobileNavSection} ${styles.showMobileNavSection}`
            : `${styles.mobileNavSection}`
        }
      >
        <div className={styles.mobileNavContainer}>
          <nav>
            <div>
              <div className={styles.mobileLogoContainer}>
                <Link
                  className={styles.logo}
                  to="/arabic"
                  aria-label="Read more about home"
                >
                  <span className={styles.logoIcon}>
                    <img src={Logo} alt="Logo" width={40} />
                  </span>
                  <span className={styles.logoText}>APEI</span>
                </Link>
                <button
                  onClick={closeMobileNav}
                  className={styles.mobileNavClose}
                  aria-label="close button"
                >
                  <FaTimes />
                </button>
              </div>
              <div>
                <div className={styles.MobileLinksContainer}>
                  <Link
                    onClick={closeMobileNav}
                    className={styles.MobileLink}
                    to="/arabic"
                    aria-label="Read more about home"
                  >
                    الرئيسية
                  </Link>

                  <Link
                    onClick={closeMobileNav}
                    className={styles.MobileLink}
                    to="/courses"
                    aria-label="Read more about courses"
                  >
                    الدورات
                  </Link>

                  <Link
                    onClick={closeMobileNav}
                    className={styles.MobileLink}
                    to="/contact"
                    aria-label="Read more about contact"
                  >
                    تواصل&nbsp;معنا
                  </Link>
                </div>
                <div className={styles.mobileLang}>
                  <Link to="/">
                    <button className={styles.mobileLogin}>English</button>
                  </Link>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Header;
